<template>
  <v-col cols="12">
    <v-slide-group v-model="slide" show-arrows>
      <v-slide-item
        v-for="(item, i) in sorted_statuses"
        class="my-4 mx-3"
        :key="i"
      >
        <goal-avatar :status="item"></goal-avatar>
      </v-slide-item>
    </v-slide-group>
  </v-col>
</template>

<script>
import { mapGetters } from "vuex";
import goalStatusTypes from "@/helpers/mixins/goalStatusTypes";
import GoalAvatar from "@/components/goals/GoalAvatar";
export default {
  name: "CoreCardGoals",
  components: { GoalAvatar },
  mixins: [goalStatusTypes],
  props: {
    coreCard: { type: Object },
    formatValue: { type: Boolean, default: false }
  },
  watch: {},
  data: () => ({
    slide: null
  }),
  computed: {
    sorted_statuses() {
      return this.sortGoalStatuses(this.coreCard.goals);
    },
    ...mapGetters({ goal_statuses: "lookup/goal_statuses" })
  },
  methods: {}
};
</script>
